import { SingleExecutionHelper } from 'cadenza/api-client/abort-controller/single-execution-helper';
import { ajax } from 'cadenza/api-client/api';
import { ConditionApi } from 'cadenza/api-client/conditions/condition-api';

export class TableConditionApi extends ConditionApi {

  #endpoint;
  #getConditionTableExecutionHelper = new SingleExecutionHelper();

  constructor ({
    conditionSetId,
    conditionName,
    conditionId,
    conditionValuesSetHashGetter
  } = {}, endpoint = '/tableConditionQuery') {
    super({ conditionSetId, conditionName, conditionId, conditionValuesSetHashGetter });
    this.#endpoint = endpoint;
  }

  setValue (selectedRows) {
    return super.setValue(selectedRows);
  }

  getValue () {
    return super.getValue().then(res => res.rows.map(row => row.values));
  }

  /**
   * @param options
   * @return {Promise<TableDataDto>}
   */
  getConditionTable (options) {
    if (Array.isArray(options.filterByColumn)) {
      options = Object.assign({}, options, {
        filterByColumn: options.filterByColumn.join()
      });
    }
    const abortController = new AbortController();
    this.#getConditionTableExecutionHelper.submit(abortController);
    return ajax(this.#endpoint, { data: { ...options, ...this.conditionQueryParams }, signal: abortController.signal });
  }

}
